/**Dependencies */
import React, { useRef, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import useForm from "../hooks/useForm";

/**Components */
import { Card, Badge, Button, Row, Col } from "react-bootstrap";
import { Currency } from "../helpers";

/**Styles */
import "../styles/components/cardProducts.scss";

/**Images */
import calendarBlue from "../images/icons/Calendario.png";
import plannerIcon from "../images/icons/time-planning.png";
import promotionIcon from "../images/icons/iconPromoción.png";
import calendarRedDown from "../images/icons/calendar-arrow-down.png";
import calendarRedUp from "../images/icons/calendar-arrow-up.png";
import relojWhite from "../images/icons/reloj.png";
import iconCertificado from "../images/icons/Certificados garantizados.png";
import viewMoreIcon from "../images/icons/Ver más.png";
import { getEmailText } from "../services/emailService";
import Swal from "sweetalert2";
import { ModalHabs } from "./ModalHabs";
import { FormContact } from "./FormContact";

export const CardsProducts = ({ infoCards, type, handleShowModal }) => {
  const textRef = useRef(null);
  const { events } = useDraggable(textRef);
  const [showModalProm, setShowModalProm] = useState(false);
  const [showModalCursos, setShowModalCursos] = useState(false);
  const [activePromId, setActivePromId] = useState(null);
  let initialState = {
    emailAddress: "info@tranet.com.mx",
    destinatarioCC: "hola@marketingdirigido.com",
    asunto: "Han Solicitado información",
    nameDest: "",
    typeProm: "",
    name: "",
    email: "",
    phone: "",
    date: "",
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit, resetForm } = useForm(
    initialState,
    validations
  );

  const submitForm = async (type) => {
    const dataArray = {
      destinatario: formData.emailAddress,
      destinatarioCC: formData.destinatarioCC,
      asunto: formData.asunto,
      mensaje:
        type === "prom"
          ? `Nombre del destino: ${formData.nameDest} \nTipo de promoción: ${formData.typeProm} \nNombre completo: ${formData.name} \nEmail: ${formData.email} \nNúmero de teléfono: ${formData.phone} \nFecha de llamada: ${formData.date}`
          : `Nombre del destino: ${formData.typeProm} \nTipo de promoción: ${formData.nameDest} \nNombre completo: ${formData.name} \nEmail: ${formData.email} \nNúmero de teléfono: ${formData.phone} \nFecha del servicio: ${formData.date}`, // Usa la interpolación correctamente
    };

    try {
      await getEmailText(dataArray);
      resetForm();
      Swal.fire({
        title: "Correo enviado exitosamente!",
        text: "El correo ha sido enviado, nos contactaremos con usted lo antes posible.",
        icon: "success",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      Swal.fire({
        icon: "error",
        title: "Hubo un error al enviar el correo.",
        text: "Por favor intentelo mas tarde.",
      });
    }
  };
  const handleShowModalProm = (id) => {
    setActivePromId(id); // Guarda el ID de la habitación activa
    setShowModalProm(true); // Muestra el modal
  };

  const handleCloseModal = () => {
    setShowModalProm(false); // Oculta el modal
    setActivePromId(null); // Limpia el ID activo
  };
  const handleShowModalCursos = (id) => {
    setActivePromId(id);
    setShowModalCursos(true); // Muestra el modal
  };

  const handleCloseCursos = () => {
    setShowModalProm(false);
    setShowModalCursos(false); // Oculta el modal
  };

  const renderContent = () => {
    switch (type) {
      case "cursos":
        return (
          <>
            <Card className="card-courses mb-4">
              <div className="position-relative">
                <Card.Img
                  variant="top"
                  src={`https://panel.internationaltravelnet.com.mx/assets/uploads/actividades_pp_galeria/${infoCards?.url_img}`}
                  alt="Grupo de estudiantes"
                  style={{ height: "158px" }}
                />
                <Badge
                  bg="danger"
                  className="badge-certificados position-absolute top-0 end-0 m-3 p-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  <div className="badge-certificados__text">
                    <img
                      src={iconCertificado}
                      alt="icono promocion"
                      style={{ width: "40px" }}
                    />
                    <br />
                  </div>
                </Badge>
              </div>
              <Card.Body className="card-courses__card-body" ref={textRef}>
                <Card.Title
                  className="card-courses__card-body__title mb-3"
                  style={{
                    textAlign: "start",
                    fontSize: "19px",
                    height: "45px",
                  }}
                >
                  {infoCards?.desc_corta}
                </Card.Title>
                <Row className="text-start mb-3">
                  <Col>
                    <div className="text-muted">Precio total</div>
                    <div className="card-courses__card-body__title fw-bold">
                      {infoCards?.precio + " " + infoCards?.tipo_moneda}
                    </div>
                  </Col>
                  {infoCards?.imp_usd > 0 && (
                    <Col>
                      <div className="text-muted">Enrollment Fee</div>
                      <div className="card-courses__card-body__title fw-bold">
                        {infoCards?.imp_usd}
                      </div>
                    </Col>
                  )}
                </Row>

                <div
                  className="flex-col items-center max-h-96 max-w-xl overflow-y-scroll rounded-lg scrollbar-hide card-products__card-body__text mt-2"
                  {...events}
                  style={{ height: "95px" }}
                  ref={textRef}
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: infoCards?.incluye }}
                  />
                </div>

                <Row className="my-3">
                  <Col
                    xs={12}
                    md={7}
                    className="card-courses__card-body__dates d-flex align-items-center mb-2"
                    style={{ textAlign: "start" }}
                  >
                    <img
                      src={calendarBlue}
                      style={{ width: "25px", marginLeft: "5px" }}
                      alt="icono calendario"
                    />
                    <span style={{ marginLeft: "5px", fontSize: "12px" }}>
                      {infoCards?.duracion}
                    </span>
                  </Col>
                  {/* <Col xs={12} md={5} className="d-flex align-items-center">
                      <img src={descubreMas} style={{width:'80px'}} alt='icon descubre mas'/>
                  </Col> */}
                </Row>
              </Card.Body>

              <Card.Footer className="card-courses__card-footer__cursos text-center">
                <Button
                  className="btn-blue"
                  onClick={() => handleShowModalCursos(infoCards?.id)}
                  id={infoCards?.id}
                  style={{ padding: "5px 15px", fontSize: "16px" }}
                >
                  <img
                    src={plannerIcon}
                    style={{ width: "22px" }}
                    alt="icono planner"
                  />{" "}
                  Pide tu cotización
                </Button>
              </Card.Footer>
            </Card>

            {showModalCursos && (
              <ModalHabs
                handleClose={handleCloseCursos}
                handleShow={handleShowModalCursos}
                title={"Contáctanos"}
                bgBody={"bg-blue-dark text-light"}
                sizeModal={"lg"}
              >
                <div className="d-flex">
                  <FormContact
                    formValue1={(formData.nameDest = infoCards?.desc_corta)}
                    nameLabel1={"Nombre del Curso"}
                    formValue2={(formData.typeProm = infoCards?.nombre)}
                    nameLabel2={"País"}
                    formValueName={formData.name}
                    formValueEmail={formData.email}
                    formValuePhone={formData.phone}
                    formValueDate={formData.date}
                    handleSubmit={(e) => handleSubmit(e, submitForm, "Cursos")}
                    handleChange={handleChange}
                  />
                </div>
              </ModalHabs>
            )}
          </>
        );
      case "sandals":
        return (
          <Card className="card-sandals">
            <Card.Img
              variant="top"
              src={infoCards?.urlImg}
              alt={`Image`}
              style={{ objectFit: "fill" }}
            />
            <Card.Body className="card-sandals__card-body" ref={textRef}>
              <Card.Title className="card-sandals__title">
                {infoCards?.hotel}
              </Card.Title>
              <Card.Text className="card-sandals__destino">
                <strong>Destino:</strong> {infoCards?.location}
              </Card.Text>
              <Card.Text style={{ textAlign: "justify", padding: "0 10px" }}>
                {infoCards?.desc}
              </Card.Text>
            </Card.Body>
            {/* <Card.Footer className='card-sandals__footer'>
              <Button
                variant="primary"
                className='card-sandals__footer__btn-modal'
                onClick={handleShowModal}
              >
                Ver más
              </Button>
            </Card.Footer> */}
          </Card>
        );
      case "seguro":
        return (
          <Card className="card-seguros">
            <Card.Img variant="top" src={infoCards?.urlImg} />
            <Card.Body className="card-seguros__card-body" ref={textRef}>
              <Card.Title className="card-seguros__card-body__title">
                {infoCards?.title}
              </Card.Title>
              <Card.Text>
                Costo por día por persona: <br />{" "}
                <span className="card-seguros__card-body__amount">
                  {infoCards?.coverAmount}
                </span>
              </Card.Text>
              <Card.Text>{infoCards?.description}</Card.Text>
            </Card.Body>
            <Card.Footer className="card-seguros__card-footer d-flex justify-content-between">
              <img
                src={viewMoreIcon}
                style={{ width: "30px" }}
                alt="icono ver mas"
              />
              <Button
                variant="primary"
                onClick={() => handleShowModal(infoCards?.modalContent)}
                className="card-seguros__card-footer__btn mx-auto"
              >
                Ver más
              </Button>
            </Card.Footer>
          </Card>
        );
      default:
        return (
          <>
            <Card
              className="card-products"
              style={{ width: "360px", height: "505px" }}
            >
              <div className="card-products__img-container">
                <Card.Img
                  variant="top"
                  src={`https://panel.internationaltravelnet.com.mx/assets/uploads/actividades_pp_galeria/${infoCards?.url_img}`}
                  alt="Curso de Inglés"
                  style={{ height: "200px", objectFit: "none" }}
                />
                <Badge
                  bg="danger"
                  className="card-products__img-container__badge"
                >
                  <img
                    src={promotionIcon}
                    alt="icono promocion"
                    style={{ width: "16px" }}
                  />
                </Badge>
              </div>

              <Card.Body className="card-products__card-body">
                <div className="card-products__card-body__price">
                  <strong className="text-red">Desde: </strong>
                  {Currency(infoCards?.precio, infoCards?.tipo_moneda)}{" "}
                  {infoCards?.tipo_moneda}
                  {infoCards?.imp && (
                    <>
                      +{Currency(infoCards?.imp, infoCards?.tipo_moneda)}{" "}
                      {infoCards?.tipo_moneda + " imp"}
                    </>
                  )}
                </div>

                <Card.Title
                  className="card-products__card-body__title text-red mt-4"
                  style={{ fontSize: "16px" }}
                >
                  {infoCards?.desc_corta}
                </Card.Title>

                <div
                  className="flex-col items-center max-h-96 max-w-xl overflow-y-scroll rounded-lg scrollbar-hide card-products__card-body__text mt-2"
                  {...events}
                  style={{ height: "170px" }}
                  ref={textRef}
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: infoCards?.incluye }}
                  />
                </div>

                <div
                  className=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "15px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={calendarRedDown}
                        alt="icono caledario down"
                        style={{ width: "22px" }}
                      />
                      <span>{infoCards?.num_dia}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={calendarRedUp}
                        alt="icono caledario up"
                        style={{ width: "22px" }}
                      />
                      <span>{infoCards?.duracion}</span>
                    </div>
                  </div>
                  <Button
                    className="btn-red"
                    onClick={() => handleShowModalProm(infoCards?.id)}
                    id={infoCards?.id}
                    style={{ padding: "5px 15px" }}
                  >
                    ¡Compra ya!
                  </Button>
                </div>
              </Card.Body>
              <Card.Footer className="card-products__card-footer">
                Tiempo limitado, ¡aprovecha ya!
                <img
                  src={relojWhite}
                  alt="icono caledario down"
                  style={{ width: "25px", marginLeft: "5px" }}
                />
              </Card.Footer>
            </Card>
            {showModalProm && (
              <ModalHabs
                handleClose={handleCloseModal}
                handleShow={handleShowModalProm}
                title={"Contáctanos"}
                bgBody={"bg-blue-dark text-light"}
                sizeModal={"lg"}
              >
                <div className="d-flex">
                  <FormContact
                    formValue1={(formData.nameDest = infoCards?.desc_corta)}
                    nameLabel1={"Nombre del destino"}
                    formValue2={(formData.typeProm = infoCards?.nombre)}
                    nameLabel2={"Tipo de promoción"}
                    formValueName={formData.name}
                    formValueEmail={formData.email}
                    formValuePhone={formData.phone}
                    formValueDate={formData.date}
                    handleSubmit={(e) => handleSubmit(e, submitForm, "Prom")}
                    handleChange={handleChange}
                  />
                </div>
              </ModalHabs>
            )}
          </>
        );
    }
  };

  return <div>{renderContent()}</div>;
};
